export function ruleUsesCustomKey(
  ruleCriterias: Record<string, unknown> | null | undefined,
  customKeyTechnicalName: string,
): boolean {
  if (!ruleCriterias || !customKeyTechnicalName) {
    return false;
  }

  const criteriaString = JSON.stringify(ruleCriterias);
  // FIXME https://gitlab.service.ops.internal.qualif.io/loyalty/loyalty/-/issues/1351

  return criteriaString.includes(`{"var":"customKeys.${customKeyTechnicalName}"}`);
}
